'use strict';

var Events = require('./events').default;

export default {

  trackClick: function (label) {
    Events.trackEvent('Time Selection', 'click', label);
  },

  trackShow: function (label) {
    Events.trackEvent('Time Selection', 'show', label);
  },

};
